import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Typography, useMediaQuery } from '@mui/material'
import theme from 'src/theme'

let Unauthenticated: FunctionComponent = () => {
  let { loginWithRedirect } = useAuth0()
  let navigate = useNavigate()

  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  let transition = 'font-size 100ms ease-in-out'

  return (
    <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          flexGrow: 1,
          position: 'relative',
          background:
            'radial-gradient(at top, rgba(66, 165, 245, 0.4) 0%, #121212 30%)',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0.12,
            background: 'url(/home-background.jpeg)',
            backgroundSize: 'cover',
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
              px: 3,
              pt: 1,
            }}
          >
            <img
              src="/background.svg"
              style={{ height: 60, width: 60, flexGrow: 0 }}
            />
            <Box sx={{ flexGrow: 1 }}></Box>
            <Button
              data-testid="register-button"
              sx={{ flexBasis: 120, mt: 1, color: 'white' }}
              variant="text"
              color="primary"
              onClick={() => {
                navigate('/register')
              }}
            >
              Register
            </Button>
            <Button
              data-testid="sign-in-button-2"
              sx={{ flexBasis: 120, mt: 1 }}
              variant="contained"
              color="primary"
              onClick={() => loginWithRedirect()}
            >
              Sign In
            </Button>
          </Box>
          <Box
            sx={{
              px: 1,
              textAlign: 'center',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: isPhone ? 16 : 28,
                fontWeight: 'bold',
                mb: 1,
                transition,
              }}
            >
              FOAMfrat Studio
            </Typography>
            <Typography sx={{ fontSize: isPhone ? 18 : 32, transition }}>
              It's Time to Start Enjoying
              <br />
              Continuing Education!
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button
                data-testid="sign-in-button-1"
                variant="contained"
                color="secondary"
                onClick={() => loginWithRedirect()}
              >
                Sign In
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          py: 3,
          px: 5,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          background: '#101010',
        }}
      >
        <Typography
          sx={{ flex: '0 1 400px', fontSize: isPhone ? 12 : 16, transition }}
        >
          FOAMfrat Studio offers EMS & nursing continuing education approved by
          CAPCE & ANCC
        </Typography>
        <Box sx={{ flexGrow: 1 }}></Box>
        <Button
          sx={{ flexBasis: isPhone ? undefined : 160, textAlign: 'center' }}
          variant="contained"
          href="https://www.foamfrat.com/emsandnursingcourse"
          target="_blank"
        >
          Learn More
        </Button>
      </Box>
    </Box>
  )
}

export default Unauthenticated
